import '../../styles/pages/search.scss';
import '../components/filters';